import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../reducks/categories/operations";
import { fetchProducts } from "../reducks/products/operations";
import { getCategories } from "../reducks/categories/selectors";
import { getProducts } from "../reducks/products/selectors";
import SortingHeader from "../components/sorting/SortingHeader";
import classes from "./ProductSorting.module.scss";
import { useGetInitialParams } from "../hooks/sorting/useGetInitalParams";
import SortingList from "../components/sorting/SortingList";
const ProductSorting = () => {
  const {
    sortedProducts,
    setSortedProducts,
    categoryList,
    categoryId,
    setCategoryId,
  } = useGetInitialParams();
  return (
    <div className="c-section-wrapin">
      <div className={classes.container}>
        <SortingHeader
          categoryList={categoryList}
          categoryId={categoryId}
          setCategoryId={setCategoryId}
          sortedProducts={sortedProducts}
        />
        <SortingList
          sortedProducts={sortedProducts}
          categoryList={categoryList}
          setSortedProducts={setSortedProducts}
          categoryId={categoryId}
        />
      </div>
    </div>
  );
};

export default ProductSorting;
